export const ConversionStatus = {
    PENDING: 0,
    STARTED: 1,
    SUCCEEDED: 2,
    FAILED: 3
};
